var _rect, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCardi1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 20,
    fill: "#FFF0E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.1667 50.6333C36.1667 45.8564 36.1667 43.468 37.6649 41.984C39.1632 40.5 41.5746 40.5 46.3974 40.5H48.1026C52.9254 40.5 55.3368 40.5 56.8351 41.984C58.3333 43.468 58.3333 45.8564 58.3333 50.6333V55.7C58.3333 60.4769 58.3333 62.8653 56.8351 64.3493C55.3368 65.8333 52.9254 65.8333 48.1026 65.8333H46.3974C41.5746 65.8333 39.1632 65.8333 37.6649 64.3493C36.1667 62.8653 36.1667 60.4769 36.1667 55.7V50.6333Z",
    stroke: "#FF6600",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6012 56.3334H59.0629C63.1973 56.3334 65.2645 56.3334 66.5489 55.0349C67.8333 53.7364 67.8333 51.6465 67.8333 47.4667V43.0334C67.8333 38.8536 67.8333 36.7637 66.5489 35.4652C65.2645 34.1667 63.1973 34.1667 59.0629 34.1667H57.6012C53.4668 34.1667 51.3996 34.1667 50.1152 35.4652C48.992 36.6007 48.851 38.3414 48.8333 41.5556",
    stroke: "#FF6600",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5 50H47.25M42.5 57.9167H50.4167",
    stroke: "#FF6600",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.625 35.75L55.9583 41.2917",
    stroke: "#FF6600",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardi1);
export default __webpack_public_path__ + "static/media/cardi1.0139d72627a36c1e5678b3be028743ee.svg";
export { ForwardRef as ReactComponent };